<template>
	<v-data-iterator
		:items="items"
		:items-per-page="itemsPerPage"
		:footer-props="{ 'show-current-page': true, 'next-icon': 'chevron_right', 'prev-icon': 'chevron_left' }"
		class="subject-grid v-data-table v-data-table--has-bottom theme--light"
		:hide-default-footer="disablePagination">

		<template v-slot:default="props">
			<div class="v-data-table__wrapper">
				<table class="subject-mapping-table">
					<thead class="v-data-table-header">
						<tr>
							<th>Matched Image</th>
							<th v-for="(header, index) in subjectFieldHeaders" :key="index">
								<v-select
									v-model="subjectFieldHeaders[index]"
									:items="visibleFieldItems"
									:label="fieldLabel(index)"
									clearable
									attach
									class="header-select"
									@change="changedSubjectFieldHeader(subjectFieldHeaders[index], index)"
									:loading="loading[index]"
									:readonly="loading[index]"
									v-if="editable" />
								<span v-else>{{ fieldLabel(index) }}</span>
							</th>
						</tr>
					</thead>
					<tbody>
						<subject-mapping-row
							v-for="(row, rowIndex) in props.items"
							:key="rowIndex"
							:row="row"
							:image-map="imageMap"
							:alt-image-map="altImageMap"
							:image-file-column="imageFileColumn"
							:matching-rows="getMatchingRows ? getMatchingRows(row, false) : []"
							:matching-subject="matchingSubjects ? matchingSubjects[rowIndex] : null"
							:subject-field-headers="subjectFieldHeaders" />
					</tbody>
				</table>
			</div>
		</template>
	</v-data-iterator>
</template>

<script>
import Vue from 'vue';
import SubjectMappingRow from './SubjectMappingRow';
import { plicV1Axios } from '../utils/axios';

const createNewFieldLabel = '+ Create New +';
export default {
	props: {
		items: null,
		subjectFieldHeaders: null,
		fieldItems: null,
		defaultRowHeader: null,
		imageMap: null,
		altImageMap: null,
		imageFileColumn: null,
		editable: null,
		itemsPerPage: null,
		getMatchingRows: null,
		project: null,
		matchingSubjects: null
	},
	data() {
		return {
			loading: {}
		};
	},
	computed: {
		visibleFieldItems() {
			return [...this.fieldItems, createNewFieldLabel];
		},
		disablePagination() {
			return this.items.length <= this.itemsPerPage;
		}
	},
	methods: {
		fieldLabel(index) {
			if(this.defaultRowHeader && this.defaultRowHeader[index]) {
				return this.defaultRowHeader[index];
			} else {
				return 'Column #' + (index + 1);
			}
		},
		changedSubjectFieldHeader(selectedField, index) {
			// Clear any other fields matching
			for(let i = 0; i < this.subjectFieldHeaders.length; i++) {
				if(i === index) {
					continue;
				}

				if(this.subjectFieldHeaders[i] == selectedField) {
					this.subjectFieldHeaders[i] = '';
				}
			}

			// See if we should prompt to create new template field
			if(this.subjectFieldHeaders[index] === createNewFieldLabel) {
				this.subjectFieldHeaders[index] = 0;

				var startValue = '';
				if(this.defaultRowHeader && this.defaultRowHeader[index]) {
					startValue = this.defaultRowHeader[index];
				}

				// TODO: Convert to Vuetify dialog so we can actually test this...
				if(window.$?.SettingsBuilderDialog) {
					window.$.SettingsBuilderDialog([
						{
							id: 'name',
							type: 'text',
							description: 'Label',
							defaultValue: startValue
						},
						{
							id: 'autoSuggest',
							type: 'checkbox',
							description: 'Group Field',
							defaultValue: false
						}
					], {
						title: 'Create New Project Field',
						onSettingsApplied: (settings) => {
							this.createSubjectFieldWithSettings(settings.name, settings.autoSuggest, index);
						}
					});
				} else {
					// So we can make automated tests for this...
					this.createSubjectFieldWithSettings(startValue, false, index);
				}
			}
		},
		createSubjectFieldWithSettings(name, autoSuggest, index) {
			let existingLabel = this.project.templateFields.find(field => field.effective_label == name);
			if(existingLabel) {
				this.subjectFieldHeaders[index] = '';
				if(window.$?.Alert) {
					window.$.Alert('Error', 'A field with this name already exists.  Use it instead.');
				}
				return;
			}

			Vue.set(this.loading, index, true);
			plicV1Axios.post('project-templates/' + this.project.plicTemplateId + '/subject-fields', {
				subject_field: {
					label: name,
					auto_suggest_enabled: autoSuggest,
					arrangement_position: this.fieldItems.length + 1
				}
			}).then((response) => {
				let newField = response.data.subject_field;
				newField.effective_label = newField.label;
				this.project.templateFields.push(newField);
				this.subjectFieldHeaders[index] = newField;
				this.loading[index] = false;
			}).catch(() => {
				this.loading[index] = false;
				window.$.Alert('Error', 'Failed to create new template field');
			});
		}
	},
	components: {
		SubjectMappingRow
	}
};
</script>

<style scoped>
	.subject-grid:deep(.v-data-footer__select) {
		display: none;
	}

	.header-select {
		min-width: 6em;
	}
	.header-select:deep(.v-menu__content) {
		max-width: initial;
	}
	.header-select:deep(.v-select__selection) {
		max-width: 100%;
	}

	.subject-mapping-table {
		min-height: 26em;
	}
</style>